import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveDown = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 11V16",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 14L9 16L11.5 14",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.3913 8H2.6087C2.27252 8 2 7.61624 2 7.14286V2.85714C2 2.38376 2.27252 2 2.6087 2H15.3913C15.7275 2 16 2.38376 16 2.85714V7.14286C16 7.61624 15.7275 8 15.3913 8Z",
			stroke: "#D9DEEB",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMoveDown);
export default ForwardRef;
